// extracted by mini-css-extract-plugin
export var col = "grid-module--col--agWJv";
export var container = "grid-module--container--AjGsB";
export var grid = "grid-module--grid--4G54Z";